import { useEffect, useState } from 'react';

import createWatermark from 'utils/canvas/createWatermark';
import useLoadingImage from 'hooks/useLoadingImage';
import { WATERMARK_PATTERN_URL } from 'configs/constants';

interface IWatermark {
  width: number;
  height: number;
}

const useWatermarkImage = ({ width, height }: IWatermark) => {
  const pattern = useLoadingImage(WATERMARK_PATTERN_URL);

  const [wmImage, setWmImage] = useState<HTMLImageElement>();

  useEffect(() => {
    if (!pattern) {
      return;
    }
    const getWatermark = async () => {
      const img = await createWatermark(pattern, {
        width,
        height,
      });
      img && setWmImage(img);
    };
    getWatermark();
  }, [pattern, width, height]);

  return wmImage;
};

export default useWatermarkImage;
